import { initializeApp, getApp, getApps } from "firebase/app";
import { getAnalytics, isSupported } from "firebase/analytics";

const firebaseConfig = {
    apiKey: process.env.REACT_APP_FB_API_KEY,
    authDomain: process.env.REACT_APP_FB_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FB_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FB_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FB_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FB_APP_ID,
    measurementId: process.env.REACT_APP_FB_MEASUREMENT_ID,
};

export const firebaseApp =
    getApps().length > 0 ? getApp() : initializeApp(firebaseConfig);

let analyticsInstance = null;
let analyticsInitPromise = null;

export function getSiteAnalytics() {
    if (analyticsInitPromise) {
        return analyticsInitPromise;
    }

    analyticsInitPromise = isSupported()
        .then((supported) => {
            if (!supported) return null;

            analyticsInstance = getAnalytics(firebaseApp);
            return analyticsInstance;
        })
        .catch(() => null);

    return analyticsInitPromise;
}

export function peekSiteAnalytics() {
    return analyticsInstance;
}